import { createReducer, on } from '@ngrx/store';

import * as fromLayoutActions from '../actions/layout.actions';
import * as fromPersistedStateActions from '../actions/persisted-state.actions';

export const layoutFeatureKey = 'layout';

export interface State {
  fullScreen: boolean;
  useMobileLayout: boolean;
}

export const initialState: State = {
  fullScreen: false,
  useMobileLayout: true
};

export const reducer = createReducer(
  initialState,
  on(fromLayoutActions.updateFullScreenLayout, (state, { payload }) => ({
    ...state,
    fullScreen: payload.fullScreen
  })),
  on(fromLayoutActions.resetLayout, (state) => ({
    ...state,
    fullScreen: false
  })),
  on(fromLayoutActions.updateUseMobileLayout, (state, { payload: { useMobileLayout } }) => ({
    ...state,
    useMobileLayout: useMobileLayout
  })),
  on(fromPersistedStateActions.persistedStateReset, fromPersistedStateActions.loadPersistedStateFailure, (state) => ({
    ...state,
    ...initialState,
    useMobileLayout: state.useMobileLayout
  })),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[layoutFeatureKey]
  }))
);
